module.exports = __webpack_public_path__ + "static/img/about-nei.6c1df4b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/about-nei.png
// module id = Um9S
// module chunks = 1